import { matchers } from '../http-request';
import { actions } from './session.actions';

const { isRequestResultSuccessFor, isRequestResultErrorFor } = matchers.core;

export const isCreateSuccess = isRequestResultSuccessFor(actions.isCreate);
export const isReadSuccess = isRequestResultSuccessFor(actions.isRead);
export const isDestroySuccess = isRequestResultSuccessFor(actions.isDestroy);
export const isSignUpSuccess = isRequestResultSuccessFor(actions.isSignUp);

export const isCreateError = isRequestResultErrorFor(actions.isCreate);
export const isReadError = isRequestResultErrorFor(actions.isRead);
export const isDestroyError = isRequestResultErrorFor(actions.isDestroy);
